// 2026-10-17 (Manak): "Code map" opens from the Kiaan widget, next to Page notes, and sits in a drawer over the
// page while Kiaan stays folded. This is the on/off switch both sides share — same pattern as pageNotesMode.
// No data fetching here, so KiaanWidget can read it without pulling the drawer chunk.
import { useSyncExternalStore } from 'react';

let on = false;
const listeners = new Set<() => void>();

export function setCodeMapMode(next: boolean): void {
  if (on === next) return;
  on = next;
  for (const l of listeners) l();
}

export function getCodeMapMode(): boolean {
  return on;
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useCodeMapMode(): boolean {
  return useSyncExternalStore(subscribe, getCodeMapMode, getCodeMapMode);
}
